import { Group, MantineTheme } from "@mantine/core";
import { IconSquareCheckFilled } from "@tabler/icons-react";
import { ReactNode } from "react";

export function BaseClientesViewColumnsOverrides(theme: MantineTheme) {
    return {
        6: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val === 'SI') {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconSquareCheckFilled style={{ color: theme.colors.green[8], minWidth: "1.3rem" }} size="1.3rem" />
                    </Group>
                }
                return value as ReactNode;
            }
        },
    }
}